var inherit = require("../../general.js").inherit;
var SortedMap = require("../../collections/sortedMap.js");
var List = require("../../collections/list.js");
var ObservableList = require("./../observableList.js");
var TreeEvent = require('./treeEvent.js');

var ObservableTreeList = function(treeNode, name, owner, validator){
    ObservableList.call(this, validator);
    this._treeNode = treeNode;
    this._name = name;
    this._owner = owner || false;
    this.handlers.bubble = null;
};
inherit(ObservableTreeList, ObservableList);
ObservableTreeList.prototype.getName = function(){ return this._name; };
ObservableTreeList.prototype.getTreeNode = function(){ return this._treeNode; };
ObservableTreeList.prototype.isOwner = function(){ return this._owner; }; 

ObservableTreeList.prototype.onBubble = function(key, handler, priority){
    console.assert(key != null && handler && typeof handler == "function", "Scheduling handler expects a valid key + handler function");
    if(!this.handlers.bubble) this.handlers.bubble = new SortedMap();
    this.handlers.bubble.put(key, handler, priority || 0);
};

ObservableTreeList.prototype.replaceWithoutTriggers = function(newVal, oldVal){
    var idx = this.indexOf(oldVal);
    this.put(idx, newVal, true);
}

ObservableTreeList.prototype.add = function(idx, val, noObservations){
    var self = this;
    if (!this.nonPersistent && this._treeNode.root && this._treeNode.root.isLocked && this._treeNode.root.isLocked(true)) return;

    if (idx < 0) idx = this.size() + idx;
    if (idx >= 0 && idx <= this.size()){
        var validated = !this.validator || this.validator(idx, val);
        if(validated) {
            List.prototype.add.call(this, idx, val);

            if (this._owner){
                if (val && val.isObservableTreeNode) val._addTreeNodeTo([this, idx]);
                for (var i = idx+1; i < this.size(); i++) { // fix parentCollection of other elements in list
                    var el = this.get(i);
                    if (el && el.isObservableTreeNode) el.parentCollection[1] = i;
                }
            } else {
                if (val && val.isObservableTreeNode) val.referrers.add([this, idx]);
                for (var i = idx+1; i < this.size(); i++) { // fix referrers of other elements in list
                    var el = this.get(i);
                    if (el && el.isObservableTreeNode){
                        el.referrers.remove([this, i-1]);
                        el.referrers.add([this, i]);
                    }
                }
            }           
            
            if(!noObservations){
                var event = new TreeEvent("add", this, idx, val);
                if (this._treeNode.root && this._treeNode.root.logEvent) this._treeNode.root.logEvent(event);
                
                this.handlers.add && this.handlers.add.forEach(function(k, handler){
                    handler.call(self, idx, val);
                });

                event.trigger();
            }
        } else {
            if(!noObservations){
                this.handlers.addFail && this.handlers.addFail.forEach(function(k, handler){
                    handler.call(self, idx, val);
                });
            }
        }
        return validated;
    }
};

ObservableTreeList.prototype.put = function(idx, val, noObservations){
    var self = this;
    if (!this.nonPersistent && this._treeNode.root && this._treeNode.root.isLocked && this._treeNode.root.isLocked(true)) return;

    if (idx < 0) idx = this.size() + idx;
    var old = this.get(idx);
    if (idx >= 0 && idx <= this.size() && old !== val) {
        var validated = !this.validator || this.validator(idx, val, old);
        if (validated) {
            List.prototype.put.call(this, idx, val);

            if (this._owner){
                if (old && old.isObservableTreeNode) old._removeTreeNode();
                if (val && val.isObservableTreeNode) val._addTreeNodeTo([this, idx]);
            } else {
                if (old && old.isObservableTreeNode) old.referrers.remove([this, idx]);
                if (val && val.isObservableTreeNode) val.referrers.add([this, idx]);
            }

            if(!noObservations){
                var event = new TreeEvent("put", this, idx, val, old);
                if (this._treeNode.root && this._treeNode.root.logEvent) this._treeNode.root.logEvent(event);

                this.handlers.put && this.handlers.put.forEach(function(k, handler) {    // TODO: put at the end of list should call onAdd handlers!
                    handler.call(self, idx, val, old);
                });

                event.trigger();
            }
        } else {
            if(!noObservations){
                this.handlers.addFail && this.handlers.addFail.forEach(function(k, handler) {
                    handler.call(self, idx, val, old);
                });
            }
        }
        return validated;
    } else return true; // TODO: put on invalid index should return false
};

ObservableTreeList.prototype.remove = function(idx, noObservations) {
    var self = this;
    if (!this.nonPersistent && this._treeNode.root && this._treeNode.root.isLocked && this._treeNode.root.isLocked(true)) return;

    if (idx < 0) idx = this.size() + idx;
    if (this.hasIndex(idx)) {
        var old = List.prototype.remove.call(this, idx);

        if (this._owner){
            if (old && old.isObservableTreeNode) old._removeTreeNode();
            for (var i = idx; i < this.size(); i++) { // fix parentCollection of other elements in list
                var el = this.get(i);
                if (el && el.isObservableTreeNode) el.parentCollection[1] = i;
            }
        } else {
            if (old && old.isObservableTreeNode) old.referrers.remove([this, idx]);
            for (var i = idx; i < this.size(); i++)  {// fix referrers of other elements in list
                var el = this.get(i);
                if (el && el.isObservableTreeNode){
                    el.referrers.remove([this, i+1]);
                    el.referrers.add([this, i]);
                }
            }
        }
        
        if(!noObservations){
            var event = new TreeEvent("remove", this, idx, undefined, old);
            if (this._treeNode.root && this._treeNode.root.logEvent) this._treeNode.root.logEvent(event);

            this.handlers.remove && this.handlers.remove.forEach(function(k, handler){
                handler.call(self, idx, old);
            });

            event.trigger();
        }

        return old;
    }
};
ObservableTreeList.prototype.removeAll = function(){
    if (!this.nonPersistent && this._treeNode.root && this._treeNode.root.isLocked && this._treeNode.root.isLocked(true)) return;
    ObservableList.prototype.removeAll.call(this);
};

ObservableTreeList.prototype.sort = undefined;  // remove sort function from observable list: no handlers will be triggered while sorting list which will result in wrong incorrectly referrers and parentCollection of list content. TODO: make this possible

ObservableTreeList.prototype.move = function(from, to){
    var val = this.get(from);
    if (val && val.isObservableTreeNode) val.removedButNotDead = true;
    ObservableList.prototype.move.call(this, from, to); // TODO: can be optimized: move does a remove and a add which will change all referrers, while only referrers of elements between the from and to index needs to changed
};

ObservableTreeList.prototype.swap = function(idx1, idx2) {
    if (idx1 < 0) idx1 = this.size() + idx1;
    if (idx2 < 0) idx2 = this.size() + idx2;
    if (this.hasIndex(idx1) && this.hasIndex(idx2) && idx1 != idx2) {   // TODO can be optimized: swap does 2 removes + 2 adds so referrers are changed 4 time while none is necessary!
        this.move(idx1, idx2);
        if (idx1 < idx2){
            if (idx2-1 != idx1) this.move(idx2-1, idx1);
        } else if (idx2+1 != idx1) this.move(idx2+1, idx1);
    }
};

module.exports = ObservableTreeList;